module.exports = __webpack_public_path__ + "img/1-06.2787f34f.png";